import { generateQueryParams } from "utils/custom-functions";
import Fetch from "utils/fetch";

export const getAllSuppliersService = () => {
  return Fetch.get(`/fornecedor/obterTodosFornecedoresComPedidosVolume`).then(({ data }) => data);
};

export const getAllBusinessUnitsService = () => {
  return Fetch.get(`/unidadeNegocio/obterTodasAsUnidadesComPedidosVolume`).then(({ data }) => data);
};

export const getAllMaterialsService = () => {
  return Fetch.get(`/materials:all-with-volume-orders`).then(({ data }) => data);
};

export const getAllStatusService = () => {
  return Fetch.get(`/pedidoVolume/obterTodosOsStatus`).then(({ data }) => data);
};

export const getAllStepsService = () => {
  return Fetch.get(`/pedidoVolume/obterTodasAsEtapas`).then(({ data }) => data);
};

export const getAllFamiliesService = () => {
  return Fetch.get(`/families:all`).then(({ data }) => data);
};

export const getAllLabeledFamiliesService = () => {
  return Fetch.get(`/labeled-families:for-filters`).then(({ data }) => data);
};

export const getAllMaterialGroupsService = async () => {
  const { data } = await Fetch.get(`/material-groups:for-filters?UseFilterDefault=false`);
  return data;
};

export const getShipmentPriorityConfigurationService = () =>
  Fetch.get(`/volumeoptimization/getShipmentPriorityConfiguration`).then(({ data }) => data);

export const getOptimizationsPaginatedService = (model: Record<string, unknown>) =>
  Fetch.get(
    `/volumeoptimization/getVolumeOptimizationPaginated?${generateQueryParams(model)}`
  ).then(({ data }) => data);




export const sendToTransportService = (model: {
  IdVolumes: number[];
  SystemPlanning: number;
  ShipmentPriority: number;
}) => Fetch.post(`/volumeoptimization/enviarParaTransporte`, model);
